import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const ServiceCard = ({ service, index, overrideCover = null }) => {
  const { t } = useLanguage();
  const label = t(`services.${service.key}.label`);
  const tagline = t(`services.${service.key}.tagline`);

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.8, delay: index * 0.05, ease: [0.22, 1, 0.36, 1] }}
    >
      <Link
        to={`/services/${service.slug}`}
        data-testid={`service-card-${service.slug}`}
        className="group block kw-img-frame aspect-[4/5] relative"
      >
        <img
          src={overrideCover || service.cover}
          alt={label}
          loading="lazy"
          decoding="async"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 z-10 flex flex-col justify-end p-6 md:p-8">
          <div className="flex items-center gap-2 mb-3">
            <span className="w-6 h-px bg-[#C5A059]" />
            <span className="overline text-[#C5A059] !text-[10px]">
              0{index + 1}
            </span>
          </div>
          <h3 className="font-serif-display text-2xl md:text-3xl text-[#F2EBE5] mb-2">
            {label}
          </h3>
          <p className="text-sm text-[#A19E9C] mb-4 max-w-xs">{tagline}</p>
          <div className="flex items-center gap-2 text-[11px] uppercase tracking-[0.28em] text-[#F2EBE5] group-hover:text-[#C5A059] transition-colors">
            <span>{t("common.discover")}</span>
            <ArrowUpRight className="w-4 h-4" strokeWidth={1.25} />
          </div>
        </div>
      </Link>
    </motion.div>
  );
};

export default ServiceCard;
